import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png";
import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button className="policy-back-btn" onClick={() => navigate(-1)} type="button">
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">Cookie Policy</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. What are cookies?</h2>
          <p>
            Cookies are small text files placed on your device when you visit a website.
            They help websites function, remember preferences, and improve experiences.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. How Kairos uses cookies</h2>
          <ul>
            <li><strong>Essential cookies:</strong> required for sign-in, security, and core functionality.</li>
            <li><strong>Preferences:</strong> remember settings like theme and language.</li>
            <li><strong>Analytics:</strong> understand product usage to improve performance and UX.</li>
            <li><strong>Marketing (optional):</strong> measure campaign performance and deliver relevant content.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Categories of cookies</h2>
          <ul>
            <li><strong>Session cookies:</strong> deleted when you close your browser.</li>
            <li><strong>Persistent cookies:</strong> remain for a period or until deleted.</li>
            <li><strong>First-party cookies:</strong> set by Kairos.</li>
            <li><strong>Third-party cookies:</strong> set by services we use (e.g., analytics/payment providers).</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Managing cookies</h2>
          <p>
            You can manage cookies in your browser settings (block, delete, or limit cookies).
            Note: blocking essential cookies may prevent login or break core features.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Consent</h2>
          <p>
            Where required, we request consent for non-essential cookies (such as analytics or marketing).
            You can update preferences anytime (for logged-in users via Settings, or via browser controls).
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Updates</h2>
          <p>
            We may update this Cookie Policy. Material changes will be communicated and the “Last updated”
            date will be revised.
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default CookiePolicy;
